(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["report-problem"] && !Shopify.designMode) return;
  try {
    
  const form = document.querySelector('.report-problem__form');

  if (form) {
    const sourceInput = form.querySelector('[data-report-problem-page]');
    const emailInput = form.querySelector('[data-report-problem-email]');
    const consentInput = form.querySelector('[data-report-problem-consent]');
    const sourceKey = 'indigo-report-problem-source-path';
    const storedPath = window.sessionStorage.getItem(sourceKey);
    const candidatePath = storedPath || window.location.pathname;
    const isRelativePath = candidatePath.startsWith('/') && !candidatePath.includes('?') && !candidatePath.includes('#');

    if (sourceInput) {
      sourceInput.value = isRelativePath ? candidatePath : window.location.pathname;
    }

    window.sessionStorage.removeItem(sourceKey);

    if (emailInput && consentInput) {
      const validateReplyPermission = () => {
        const needsPermission = emailInput.value.length > 0 && !consentInput.checked;
        consentInput.setCustomValidity(needsPermission ? consentInput.dataset.requiredMessage : '');
      };

      emailInput.addEventListener('input', validateReplyPermission);
      consentInput.addEventListener('change', validateReplyPermission);
      form.addEventListener('submit', validateReplyPermission);
    }
  }

  } catch(e) { console.error(e); }
})();
})();
